import React, { FC } from 'react'

type Props = {
  value: string | undefined
  type?: 'date' | 'datetime-local'
  style?: React.CSSProperties
  onChange(value: string | undefined): void
}

export const DateTimePicker: FC<Props> = ({
  value,
  onChange,
  type = 'datetime-local',
  ...props
}) => {
  return (
    <input
      type={type}
      value={value || ''}
      onChange={e => {
        try {
          onChange(e.target.value || undefined)
        } catch (error) {
          console.error('Date time picker error', (error as Error)?.message)
          onChange(undefined)
        }
      }}
      {...props}
    />
  )
}

export type TemporaryDatePickerProps = Props
